var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { nvFetch } from '../helpers/nvFetch';
import { extensionUnregistered } from './extension';
import { finaliseLogout } from './user';
const initialState = {
    calls: [],
    isFetching: false,
    error: undefined,
    visibilityFilter: 'SHOW_CALLS',
    searchString: '',
    params: {
        includeLocal: true,
        pageSize: 40,
        page: 0,
    },
    reachedEnd: false,
    scrolledPage: 0,
};
export const fetchCallHistory = createAsyncThunk('callHistory/fetch', (_a, thunkAPI_1) => __awaiter(void 0, [_a, thunkAPI_1], void 0, function* ({ overrideParams = {}, force = false }, thunkAPI) {
    var _b, _c;
    const state = thunkAPI.getState();
    const { callHistory } = state;
    const customerId = (_b = state.client.activeCustomer) === null || _b === void 0 ? void 0 : _b.id;
    const id = (_c = state.extension.extension) === null || _c === void 0 ? void 0 : _c.id;
    let myURI;
    if (!overrideParams.endpointId) {
        myURI = (id === null || id === void 0 ? void 0 : id.replace(/^0+/, '')) || '';
    }
    else {
        myURI = overrideParams.endpointId.replace(/^0+/, '');
    }
    const correctDirection = (calls) => {
        return calls.map((call) => {
            if (call.srcEndpoint === myURI) {
                call.direction = 'OUT';
            }
            else {
                call.direction = 'IN';
            }
            return call;
        });
    };
    const { params } = callHistory;
    const updatedParams = Object.assign(Object.assign(Object.assign({}, params), { page: callHistory.scrolledPage + 1, endpointId: myURI }), overrideParams);
    // Limit to last 7 days
    const weekAgoTs = Date.now() - 1000 * 60 * 60 * 24 * 7;
    updatedParams.startedAfter = new Date(weekAgoTs).toISOString();
    thunkAPI.dispatch(callHistorySlice.actions.fetchCallHistoryStarted(updatedParams));
    const fetchRes = yield nvFetch(`/customers/${customerId}/calls`, {
        params: updatedParams,
    });
    const res = correctDirection((yield fetchRes.json()).items || []);
    return { newCalls: res, isForced: force };
}), {
    condition: ({ force, overrideParams = {} }, thunkAPI) => {
        var _a;
        const state = thunkAPI.getState();
        const { callHistory } = state;
        const id = (_a = state.extension.extension) === null || _a === void 0 ? void 0 : _a.id;
        if (callHistory.isFetching || (!force && callHistory.reachedEnd)) {
            return false;
        }
        if (!id && !overrideParams.endpointId) {
            return false;
        }
    },
});
export const fetchNewCalls = createAsyncThunk('callHistory/fetchNewCalls', (_, thunkAPI) => {
    const { callHistory: { newestCallCreatedTime }, } = thunkAPI.getState();
    const params = {
        page: 1,
    };
    if (newestCallCreatedTime) {
        params.createdAfter = newestCallCreatedTime;
    }
    thunkAPI.dispatch(fetchCallHistory({ overrideParams: params, force: true }));
});
const callHistorySlice = createSlice({
    name: 'callHistory',
    initialState,
    reducers: {
        fetchCallHistoryStarted: (state, action) => {
            const params = action.payload;
            // keep track of the highest page we have scrolled to
            let scrolledPage = state.scrolledPage;
            if (params.page > scrolledPage) {
                scrolledPage = params.page;
            }
            state.isFetching = true;
            state.params = params;
            state.scrolledPage = scrolledPage;
        },
        callHistoryReset: () => initialState,
        visibilityFilterSet: (state, action) => {
            state.visibilityFilter = action.payload.filter;
        },
        // FIXME those names...
        callHistorySearched: (state, action) => {
            state.searchString = action.payload.searchString;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCallHistory.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.error;
        })
            .addCase(fetchCallHistory.fulfilled, (state, action) => {
            const calls = [...state.calls];
            const { newCalls, isForced } = action.payload;
            const callsMap = new Map();
            // No new calls!
            if (newCalls.length <= 0) {
                state.isFetching = false;
                state.error = undefined;
                state.reachedEnd = !isForced ? true : state.reachedEnd;
                return;
            }
            /**
             * Check to see if the srcEndpoint of one of the calls in
             * the call history is the same as one of the calls in
             * the newly fetched calls. If it's not, it means we've
             * fetched a new extensions set of calls, so drop the
             * old calls and just use the newly fetched calls
             */
            /* if (calls.length > 0 && newCalls.length > 0) {
              const oldSrcEndpoint = calls[0].srcEndpoint;
              const newSrcEndpoint = newCalls[0].srcEndpoint;
              if (newSrcEndpoint !== oldSrcEndpoint) {
                return {
                  ...state,
                  calls: newCalls,
                  isFetching: false,
                  error: null,
                  reachedEnd: false
                };
              }
            } */
            // Create a map of current calls, id to index
            calls.forEach((c, i) => callsMap.set(c.id, i));
            // Use the above map to ensure we don't
            // insert duplicate calls
            newCalls.forEach((n) => {
                const callsIdx = callsMap.get(n.id);
                if (typeof callsIdx === 'undefined') {
                    calls.push(n);
                }
            });
            // Sort the calls by callStarted (descending)
            calls.sort((a, b) => {
                const keyA = new Date(a.callStarted);
                const keyB = new Date(b.callStarted);
                // Compare the 2 dates
                if (keyA < keyB)
                    return 1;
                if (keyA > keyB)
                    return -1;
                return 0;
            });
            state.calls = calls;
            state.isFetching = false;
            state.error = undefined;
            state.newestCallCreatedTime = calls[0].created;
        })
            // FIXME should we avoid this kind of thing? Just directly reset state inside component when the extension is unregistering?
            .addCase(extensionUnregistered, () => {
            return initialState;
        })
            .addCase(finaliseLogout.fulfilled, () => initialState);
    },
});
export const { callHistoryReset, visibilityFilterSet } = callHistorySlice.actions;
export default callHistorySlice.reducer;
